/**
 * data/accommodation.ts — the BnB side of Grace Haven.
 */
import { IMG } from './images';
export interface Room {
  id: string;
  name: string;
  price: number; // BWP per night
  sleeps: string; // e.g. "Sleeps 2"
  blurb: string;
  features?: string[];
  image?: string;
}

export const ROOMS: Room[] = [
  {
    id: 'cosy',
    name: 'Cosy Room',
    price: 200,
    sleeps: 'Sleeps 1–2',
    blurb: 'A snug, restful room for a solo escape or a couple — calm and close to the spa.',
    features: ['Double bed', 'En-suite', 'DSTV & Netflix', 'Fast WiFi'],
    image: IMG.room,
  },
  {
    id: 'standard',
    name: 'Standard Room',
    price: 300,
    sleeps: 'Sleeps 2',
    blurb: 'A comfortable double with a little more space to settle in and unwind.',
    features: ['Queen bed', 'En-suite', 'DSTV & Netflix', 'Fast WiFi'],
    image: IMG.suite,
  },
  {
    id: 'deluxe',
    name: 'Deluxe Room',
    price: 350,
    sleeps: 'Sleeps 2–3',
    blurb: 'Our most spacious room — a touch more comfort for a special stay.',
    features: ['Queen bed + sleeper', 'En-suite', 'DSTV & Netflix', 'Fast WiFi'],
    image: IMG.stayPillar,
  },
];

/** Typical Botswana lodge / BnB policies. Edit to match house rules. */
export const STAY_POLICY = {
  checkIn: 'From 14:00',
  checkOut: 'By 10:00',
  conditions: [
    'Rates are per room, per night, in Botswana Pula (BWP).',
    'Self-catering — guests have kitchen access; meals are not included.',
    'A valid ID or passport is required at check-in.',
    'Full payment is due on or before check-in.',
    'Early check-in or late check-out is available on request, subject to availability.',
    'No smoking indoors. Quiet hours apply from 22:00.',
    'Free WiFi, DSTV & Netflix, and pool and garden access for all guests.',
    'Cancellations are free up to 48 hours before check-in.',
  ],
} as const;

export const AMENITIES = {
  selfCatering: ['DSTV', 'Netflix', 'Showmax', 'High-speed WiFi'],
  facilities: [
    'Swimming pool',
    'Garden',
    'Discount on spa services',
    'Secure parking',
    '24-hour security',
  ],
} as const;
